import { html, classes } from '../core/html.js';
import { t } from '../core/i18n.js';
import { routeHref } from '../core/url.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { artwork } from '../components/artwork.js';
import { ctaSection } from '../components/ctaSection.js';
import { icon } from '../components/icon.js';
import { projects } from '../data/projects.js';

const pad = (value) => String(value).padStart(2, '0');

const pageHead = () => html`
  <section class="pagehead" aria-labelledby="lab-title">
    <div class="shell">
      ${breadcrumbs('nav.lab')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('lab.label')}</p>
          <h1 class="pagehead__title" id="lab-title">${t('lab.title')}</h1>
          <p class="pagehead__lede">${t('lab.lede')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="pagehead__note">
            <strong>${pad(projects.length)}</strong>${t('lab.count')}
          </p>
          <p class="pagehead__meta">
            ${projects.map((project) => html`<span>${project.name}</span>`)}
          </p>
          <a class="link-arrow" href="${routeHref('/blog')}">
            ${t('lab.blog')}${icon('arrowRight', { size: 15 })}
          </a>
        </aside>
      </div>
    </div>
  </section>
`;

const spotlight = (project, index) => html`
  <section
    class="${classes('spotlight', 'spotlight--lab', index % 2 === 1 && 'spotlight--flip')}"
    id="${project.slug}"
    style="--accent: ${project.accent}"
    aria-labelledby="${project.slug}-title"
  >
    <div class="shell spotlight__grid">
      <div>
        <div class="spotlight__status-line">
          <p class="spotlight__status">${t(`state.${project.state}`)}</p>
          <p class="spotlight__note">${t(`lab.${project.slug}.kind`)}</p>
        </div>
        <h2 class="spotlight__title" id="${project.slug}-title">${project.name}</h2>
        <p class="spotlight__text">${t(`lab.${project.slug}.description`)}</p>
        <ul class="tag-list">
          ${Array.from({ length: project.facts }, (_, fact) => html`
            <li>${t(`lab.${project.slug}.fact${fact + 1}`)}</li>
          `)}
        </ul>
        <div class="spotlight__actions">
          <a class="btn btn--paper btn--lg" href="${routeHref(project.link)}">
            ${t(`lab.${project.slug}.cta`)}${icon('arrowRight', { size: 17 })}
          </a>
        </div>
      </div>
      <div class="spotlight__art">
        ${artwork(project.art, t(`lab.${project.slug}.alt`), {
          sizes: '(max-width: 919px) 92vw, 46vw',
          priority: index === 0,
        })}
      </div>
    </div>
  </section>
`;

const reasons = () => html`
  <section class="section principles" aria-labelledby="why-title">
    <div class="shell">
      <div class="section-label">
        <span class="section-label__num">02</span>
        <span>${t('lab.why.label')}</span>
      </div>
      <div class="section-head">
        <h2 class="section-head__title" id="why-title">${t('lab.why.title')}</h2>
      </div>
      <div class="principles__grid">
        ${[1, 2, 3].map(
          (index) => html`
            <article class="principle" data-reveal>
              <span class="principle__num" aria-hidden="true">${pad(index)}</span>
              <h3 class="principle__title">${t(`lab.why${index}.title`)}</h3>
              <p class="principle__text">${t(`lab.why${index}.text`)}</p>
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;

export const LabPage = () => page(html`
  ${pageHead()}${projects.map((project, index) => spotlight(project, index))}${reasons()}
  ${ctaSection({
    labelKey: 'lab.cta.label',
    titleKey: 'lab.cta.title',
    ledeKey: 'lab.cta.lede',
    buttonKey: 'lab.cta.button',
  })}
`);
